var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#D0E0E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1673 15.9167V14.0833M10.234 20.5H17.0173C18.5575 20.5 19.3275 20.5 19.9158 20.2003C20.4332 19.9366 20.8539 19.5159 21.1176 18.9985C21.4173 18.4102 21.4173 17.6401 21.4173 16.1V13.9C21.4173 12.3599 21.4173 11.5898 21.1176 11.0015C20.8539 10.4841 20.4332 10.0634 19.9158 9.79973C19.3275 9.5 18.5575 9.5 17.0173 9.5H10.234C8.69384 9.5 7.92377 9.5 7.33551 9.79973C6.81806 10.0634 6.39737 10.4841 6.13372 11.0015C5.83398 11.5898 5.83398 12.3599 5.83398 13.9V16.1C5.83398 17.6401 5.83398 18.4102 6.13372 18.9985C6.39737 19.5159 6.81806 19.9366 7.33551 20.2003C7.92377 20.5 8.69384 20.5 10.234 20.5Z",
    stroke: "#45748C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 12.4333C5.83398 11.4066 5.83398 10.8932 6.11706 10.501C6.36607 10.1561 6.76339 9.87559 7.25209 9.69982C7.80767 9.5 8.53496 9.5 9.98954 9.5H17.2618C18.7163 9.5 19.4436 9.5 19.9992 9.69982C20.4879 9.87559 20.8852 10.1561 21.1342 10.501C21.4173 10.8932 21.4173 11.4066 21.4173 12.4333V17.5667C21.4173 18.5934 21.4173 19.1068 21.1342 19.499C20.8852 19.8439 20.4879 20.1244 19.9992 20.3002C19.4436 20.5 18.7163 20.5 17.2618 20.5H9.98954C8.53496 20.5 7.80767 20.5 7.25209 20.3002C6.76339 20.1244 6.36607 19.8439 6.11706 19.499C5.83398 19.1068 5.83398 18.5934 5.83398 17.5667V12.4333Z",
    stroke: "#45748C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6227 13.2082C12.7572 12.494 11.314 12.3018 10.2297 12.9558C9.14529 13.6098 8.99263 14.7033 9.84418 15.4768C10.3896 15.9722 11.7865 16.8909 12.7203 17.4874C13.0306 17.6857 13.1858 17.7848 13.3716 17.8245C13.5314 17.8587 13.714 17.8587 13.8737 17.8245C14.0596 17.7848 14.2148 17.6857 14.5251 17.4874C15.4589 16.8909 16.8558 15.9722 17.4012 15.4768C18.2527 14.7033 18.1187 13.603 17.0157 12.9558C15.9127 12.3087 14.4881 12.494 13.6227 13.2082Z",
    stroke: "#45748C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryHealth);
export default __webpack_public_path__ + "static/media/batteryHealth.3728a536b8d9f1d22dc57cc7e537dda8.svg";
export { ForwardRef as ReactComponent };